// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Xjys","label":"styles_label__zMxaX"};